@if (loading) {
  <div class="h-full w-full">
    <app-loading [loading]="loading"></app-loading>
  </div>
} @else {
  <div class="data-table-container">
    <p-table
      [value]="data"
      [paginator]="true"
      [rows]="rows"
      [(first)]="first"
      [lazy]="true"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="currentPageReportTemplate"
      [loading]="loading"
      [totalRecords]="totalRecords"
      loadingIcon="pi pi-spin pi-spinner fast-spinner"
      (onPage)="onPageChange($event)"
      class="custom-table">

      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="config.selectable" style="width: 50px;">
            <p-checkbox
              [(ngModel)]="selectAll"
              (onChange)="onSelectAllToggle()">
            </p-checkbox>
          </th>
          <th *ngFor="let col of columns"
              [style.width]="col.width"
              [style.min-width]="col.minWidth"
              [pSortableColumn]="col.sortable === true ? col.field : undefined"
              [class.sortable-header]="col.sortable === true"
              [attr.rowspan]="col.rowspan ? col.rowspan : null"
              [attr.colspan]="col.colspan ? col.colspan : null">
            {{ col.header | translate }}
            <div [style.color]="'var(--table-header-text)'" class="header-subtitle">
              {{ $any(col?.headerSubtitle) | translate }}
            </div>
            <p-sortIcon *ngIf="col.sortable === true" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>


      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr (click)="onRowClickChange(row)" [class.clickable-row]="config.selectable">
          <td *ngIf="config.selectable">
            <p-checkbox
              [(ngModel)]="row.selected"
              (onChange)="onRowSelectChange(row)">
            </p-checkbox>
          </td>
          <td *ngFor="let col of columns"
              [style.width]="col.width"
              [style.min-width]="col.minWidth">
            <span *ngIf="col.parseFunction">
                {{ formatCellText(getCellValue(row, col)) }}
            </span>
            <ng-container *ngIf="!col.parseFunction" [ngSwitch]="col.type">
              <!-- Text -->
              <span *ngSwitchCase="'text'" [title]="formatCellText(row[col.field])">
              {{ formatCellText(row[col.field]) }}
            </span>

              <!-- Date -->
              <span *ngSwitchCase="'date'">
              {{ formatDate(row[col.field]) }}
            </span>

              <span *ngSwitchCase="'double'" class="text-align-right">
                {{ row[col.field] | msfNumber : tr.currentLang }}
            </span>

              <span *ngSwitchCase="'number'" class="text-align-right">
                {{ row[col.field] }}
            </span>

              <!-- localizationString -->
              <span *ngSwitchCase="'localizationString'">
              {{ getLocalizedValue(row, col.field) }}
            </span>

              <!-- File Size -->
              <span *ngSwitchCase="'fileSize'" class="text-align-right">
              {{ formatFileSize(row[col.field]) }}
            </span>

              <!-- Badge -->
              <span *ngSwitchCase="'badge'"
                    class="badge"
                    [ngClass]="col.badgeClass ? col.badgeClass(row[col.field]) : ''">
              {{ row[col.field] | translate }}
            </span>

              <!-- Boolean -->
              <span *ngSwitchCase="'boolean'">
              <i class="pi"
                 [ngClass]="row[col.field] ? 'pi-check text-success' : 'pi-times text-danger'">
              </i>
            </span>

              <!-- Actions -->
              <div *ngSwitchCase="'actions'" class="action-buttons">
                <button
                  *ngFor="let action of config.actions | slice:0:1"
                  pButton
                  type="button"
                  [icon]="action.icon"
                  [class]="action.class || 'p-button-text p-button-sm'"
                  [pTooltip]="action.tooltip ? (action.tooltip | translate) : ''"
                  tooltipPosition="top"
                  [style.display]="isActionVisible(action, row) ? 'inline-flex' : 'none'"
                  (click)="executeAction(action, row); $event.stopPropagation()">
                </button>
              </div>

              <!-- Custom template -->
              <ng-container *ngSwitchCase="'custom'">
                <ng-container
                  *ngTemplateOutlet="col.customTemplate; context: { $implicit: row, rowIndex: rowIndex, col:col,  fieldName: col.field }">
                </ng-container>
              </ng-container>

              <!-- Default -->
              <span *ngSwitchDefault>
              {{ formatCellText(getCellValue(row, col)) }}
            </span>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="config.selectable ? columns.length + 1 : columns.length" class="empty-message">
            {{ config.emptyMessage || ('No data found' | translate) }}
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="paginatorleft">
        <div class="paginator-left-container">
          <div class="total-records">
            {{ 'Total' | translate }}: {{ totalRecords }}
          </div>
          <div class="page-size-selector">
            <select [(ngModel)]="rows" (change)="onPageSizeChange(rows)" class="rows-per-page">
              <option *ngFor="let option of config.rowsPerPageOptions || [10, 25, 50, 100]" [value]="option">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
      </ng-template>
    </p-table>
  </div>
}
